export function filterExtraApplications(ids, applications){
    return applications.filter(app => !ids.includes(app.id))
}

export function getUrl(app){
    if([2101, 2102, 2104].includes(app.id)){ // IB, CM, Spare parts
        return "#" + app.rootUrl.substring(app.rootUrl.lastIndexOf('/'));
    }
    return app.rootUrl
}

export function getType(app){
    if([2101, 2102, 2104].includes(app.id)){ // IB, CM, Spare parts
        return 'component'
    }
    if (!app.externalSite || app.showInSameTab) {
        return 'same-tab'
    }
    return 'external'
}